/** Hands the browser to Calendar's subscription handler; the page itself stays. */
export function openInCalendar(url: string): void {
  window.location.href = url;
}
